import AssessmentsAdapter from './base';

export default class GradeSchedule extends AssessmentsAdapter {
  modelNamePlural = 'gradeSchedules';
}
